import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row } from 'react-bootstrap';
import LmsStatItem from './LmsStatItem';

const LmsStats = ({ data }) => {
  return (
    <Card className="mb-3">
      <Card.Body>
        <Row className="g-0">
          <LmsStatItem
            title={data.assessment_location}
            description="Project Name"
            className="project-border-md-end project-border-bottom border-xxl-bottom-0 pb-2 ps-md-0"
          />
          <LmsStatItem
            title={data.assessment_state}
            description="State"
            className="project-border-xxl-end project-border-bottom border-xxl-bottom-0 py-2 pt-md-0 pe-md-0"
          />
          <LmsStatItem
            title={data.assessment_date}
            description="Pre-Assessment Date"
            className="project-border-md-end project-border-bottom border-md-bottom-0 py-2 pb-md-0 ps-md-0 ps-xxl-3"
          />
          <LmsStatItem
            title={data.assessment_area}
            description="Project Area"
            className="pt-2 pb-0 pe-md-0"
          />
        </Row>
      </Card.Body>
    </Card>
  );
};

LmsStats.propTypes = {
  data: PropTypes.object.isRequired
};

export default LmsStats;
